// 1. Função que obtém o valor do frete da região
function getFreteValueFromRegion() {
  return new Promise((resolve) => {
    const saved = localStorage.getItem('valueTax');
    if (saved) return resolve(parseFloat(saved));

    fetch('https://ipinfo.io?token=140a676aebc5e1')
      .then(res => res.json())
      .then(data => {
        const region = data.region;
        let valueTax = 0;
        if (["São Paulo", "Rio de Janeiro", "Paraná", "Rio Grande do Sul", "Santa Catarina", "Minas Gerais", "Espírito Santo"].includes(region)) {
          valueTax = 199;
        } else {
          valueTax = 299;
        }
        localStorage.setItem('valueTax', valueTax);
        resolve(valueTax);
      })
      .catch(() => resolve(299)); // fallback
  });
}

// 2. Atualiza a barra visual
function updateShippingBar(cartTotal, valueTax) {
  const fill = document.getElementById('shipping-fill');
  const text = document.getElementById('shipping-text');

  if (!fill || !text) return;

  const progress = Math.min((cartTotal / valueTax) * 100, 100);
  const valorRestante = Math.max(valueTax - cartTotal, 0).toFixed(2);

  fill.style.width = `${progress}%`;

  if (cartTotal >= valueTax) {
    text.innerText = "Parabéns você ganhou frete grátis!";
  } else {
    text.innerText = `Falta R$ ${valorRestante.replace('.', ',')} para obter frete grátis`;
  }
}

// 3. Busca os dados do carrinho (Shopify AJAX API)
function fetchCartAndUpdateBar() {
  getFreteValueFromRegion().then((valueTax) => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const totalCart = cart.total_price / 100;
        updateShippingBar(totalCart, valueTax);
      });
  });
}

// 4. MutationObserver para detectar mudanças no carrinho
function observeCartChanges() {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        // Aguarda um pouco para o carrinho atualizar visualmente
        setTimeout(fetchCartAndUpdateBar, 500);
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// 5. Inicialização
document.addEventListener('DOMContentLoaded', () => {
  fetchCartAndUpdateBar();
  observeCartChanges();
});
